import {queryOptions} from '@tanstack/react-query';
import {fetchBillingFreeLimits} from './fetchBillingFreeLimits';

export const billingFreeLimitsQuery = queryOptions({
  queryFn: fetchBillingFreeLimits,
  queryKey: ['billing', 'free-limits'],
});
